import { render, staticRenderFns } from "./PackageSaveShareOverlay.vue?vue&type=template&id=462669f8&scoped=true"
import script from "./PackageSaveShareOverlay.vue?vue&type=script&lang=js"
export * from "./PackageSaveShareOverlay.vue?vue&type=script&lang=js"
import style0 from "./PackageSaveShareOverlay.vue?vue&type=style&index=0&id=462669f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462669f8",
  null
  
)

export default component.exports